import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { SearchComponent } from '../../components/parts-management/parts-management-search/parts-management-search.component';
import { PartsManagementGridComponent } from '../../components/parts-management/parts-management-grid/parts-management-grid.component';
import { FiltersComponent } from '../../components/parts-management/parts-management-filter/parts-management-filters.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterModule } from '@angular/router';

import { PartsManagementFilterForm } from '../../form-model/parts-management-filter.form.model';
import { PartsManagementSearchTextForm } from '../../form-model/parts-management-search-text.form.model';

@Component({
  selector: 'app-parts-management',
  templateUrl: './parts-management.component.html',
  styleUrls: ['./parts-management.component.scss'],
  imports: [
    SearchComponent,
    RouterLink,
    RouterModule,
    PartsManagementGridComponent,
    FiltersComponent,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PartsManagementComponent {
  filterFormGroup = this.formBuilder.group({
    partsManagementFilterForm: this.formBuilder.group<PartsManagementFilterForm>({} as PartsManagementFilterForm),
    partsManagementSearchTextForm: this.formBuilder.group<PartsManagementSearchTextForm>({} as PartsManagementSearchTextForm),
  });
  isPartsManagementList = false;
  constructor(private readonly formBuilder: FormBuilder) {}
}
